import type { ContentDefinition, PluginDefinition } from "@magic-md/core";
import type { RuntimeUnitInfo } from "../types/index";

const PRIVATE_IMPORT_SEGMENT = "/__import__/";

export function isUserPrivateReferenceId(id: string): boolean {
    return id.includes(PRIVATE_IMPORT_SEGMENT);
}

export function filterSelectableDefinitions(
    definitions: Map<string, PluginDefinition>,
    currentDefinitionId?: string,
): Map<string, PluginDefinition> {
    return new Map(
        [...definitions.entries()].filter(([id]) => (
            id !== currentDefinitionId && !isUserPrivateReferenceId(id)
        )),
    );
}

export function filterSelectableContentDefinitions(
    definitions: Map<string, ContentDefinition>,
    currentDefinitionId?: string,
): Map<string, ContentDefinition> {
    return new Map(
        [...definitions.entries()].filter(([id]) => (
            id !== currentDefinitionId && !isUserPrivateReferenceId(id)
        )),
    );
}

export function filterSelectableUnits(
    units: RuntimeUnitInfo[],
    currentDefinitionId?: string,
): RuntimeUnitInfo[] {
    return units.filter((unit) => (
        unit.id !== currentDefinitionId && !isUserPrivateReferenceId(unit.id)
    ));
}
